import { Component, Input } from '@angular/core';
import { BillingAddress } from '../../../models/billing-address';
import { OrderStepBaseComponent } from '../../order-step-base-component';
import { environment } from '../../../../environments/environment';
import { OrderState } from 'app/order/models';

@Component({
    selector: 'app-billing-address-display',
    templateUrl: './billing-address-display.component.html',
    standalone: false,
})
export class BillingAddressDisplayComponent extends OrderStepBaseComponent {
    @Input()
    public billingAddress: Partial<BillingAddress>;
    public constructor() {
        super();
    }

    public get isCompany(): boolean {
        return this.billingAddress?.title?.id === environment.titleCompanyId;
    }

    public getData(): Partial<OrderState> {
        return {};
    }
}
